module.exports = __webpack_public_path__ + "img/legend-logo-white.81876a54.svg";